import { render, staticRenderFns } from "./van-img.vue?vue&type=template&id=7481031a&scoped=true&"
import script from "./van-img.vue?vue&type=script&lang=js&"
export * from "./van-img.vue?vue&type=script&lang=js&"
import style0 from "./van-img.vue?vue&type=style&index=0&id=7481031a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481031a",
  null
  
)

export default component.exports